import {Action, combineReducers} from "redux"
import appReducer from "./containers/App/appSlice"

import {ThunkAction} from "redux-thunk"
import accessPoliciesSlice from "./containers/AccessPolicies/accessPoliciesSlice"
import activitySlice from "./containers/Activity/activitySlice"
import customerSliceReducer from "./containers/Customer/customerSlice"
import customPricesSliceReducer from "./containers/CustomPrices/customPricesSlice"
import dashboardSlice from "./containers/Dashboard/dashboardSlice"
import dvsaFeesSliceReducer from "./containers/DvsaFees/dvsaFeesSlice"
import schedulesSliceReducer from "./containers/DVSASchedules/schedulesSlice"
import DvsaTest from "./containers/DvsaTest/dvsatestsSlice"
import feesSliceReducer from "./containers/Fees/feesSlice"
import bookingSlice from "./containers/MotBooking/bookingSlice"
import motHistorySliceReducer from "./containers/MotHistory/motHistorySlice"
import passRateReportSlice from "./containers/PassRate/passRateReportSlice"
import RADSliceReducer from "./containers/RegionAndDealers/RADSlice"
import testStationSliceReducer from "./containers/TestStation/testStationSlice"
import userSliceReducer from "./containers/User/userSlice"
import vehicleSlice from "./containers/Vehicles/vehicleSlice"

const rootReducer = combineReducers({
    application: appReducer,
    containers: combineReducers({
        customer: customerSliceReducer,
        motHistory: motHistorySliceReducer,
        users: userSliceReducer,
        fees: feesSliceReducer,
        dvsaFees: dvsaFeesSliceReducer,
        customPrices: customPricesSliceReducer,
        regions: RADSliceReducer,
        testStations: testStationSliceReducer,
        schedules: schedulesSliceReducer,
        dvsaTest: DvsaTest,
        vehicles: vehicleSlice,
        motBooking: bookingSlice,
        passRateReport: passRateReportSlice,
        activity: activitySlice,
        dashboard: dashboardSlice,
        accessPolicies: accessPoliciesSlice,
    }),
})

export type RootState = ReturnType<typeof rootReducer>

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>

export default rootReducer
